import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Label from "./label";
import { cn } from "../../utility/utils";

const DateInput = ({
  className,
  label = "label",
  rules,
  name,
  control,
  maxDate,
  onChangeFn,
  onChangeRaw,
  onCalendarClose,
  onBlur,
  placeholderText,
  ...props
}) => {
  const parseToValidDate = (val) => {
    if (!val) return null;
    if (val instanceof Date) {
      return isNaN(val.getTime()) ? null : val;
    }

    // 1. If it's a string containing non-numeric date chars (like "2025-01-01", "2025/01/01", ISO strings)
    if (typeof val === "string" && (val.includes("-") || val.includes("/") || val.includes("T"))) {
      // If formatted as DD/MM/YYYY
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
        const [day, month, year] = val.split("/");
        const d = new Date(Number(year), Number(month) - 1, Number(day));
        return isNaN(d.getTime()) ? null : d;
      }
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d;
    }

    // 2. If it's a numeric timestamp (number or purely numeric string)
    const num = Number(val);
    if (!isNaN(num) && num > 0) {
      // 10-digit Unix timestamp in seconds vs 13-digit milliseconds
      const d = num < 10000000000 ? new Date(num * 1000) : new Date(num);
      return isNaN(d.getTime()) ? null : d;
    }

    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d;
  };

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <div className="flex flex-col space-y-2">
            <Label>
              {label}
              {rules?.required && <span className="text-red-600">*</span>}
            </Label>
            <div>
              <DatePicker
                selected={parseToValidDate(value)}
                onChange={(date) => {
                  onChange(date);
                  onChangeFn?.(date);
                }}
                onBlur={onBlur}
                onChangeRaw={onChangeRaw}
                onCalendarClose={onCalendarClose}
                maxDate={maxDate}
                placeholderText={placeholderText}
                dateFormat="dd/MM/yyyy"
                className={cn(
                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                  className
                )}
                autoComplete="off"
                {...props}
              />
            </div>
            {error && (
              <small className="text-red-600 font-medium block pt-1 text-sm">
                {error.message}
              </small>
            )}
          </div>
        )}
      />
    </>
  );
};

export default DateInput;
